const JSON_STRING_FIELD = /"([^"\\]{1,100})"(\s*):(\s*)"((?:[^"\\]|\\.)*)"/g;
const SENSITIVE_KEY = /password|email|token|authorization|cookie/i;

export const mapCookies = (cookieHeader: string = '') => cookieHeader
  .split(';')
  .reduce((acc, cookie) => {
    const [name, ...value] = cookie.trim().split('=');

    if (name) {
      acc[name] = value.join('=').length;
    }

    return acc;
  }, {} as Record<string, number>);

export const maskSensitiveData = (text: string = '') => text.replace(
  JSON_STRING_FIELD,
  (match, key: string, spaceBefore: string, spaceAfter: string, value: string) => {
    if (!SENSITIVE_KEY.test(key)) {
      return match;
    }

    const maskedValue = key.toLowerCase().includes('cookie')
      ? JSON.stringify(mapCookies(value))
      : '"***"';

    return `"${key}"${spaceBefore}:${spaceAfter}${maskedValue}`;
  },
);

/**
 * @function
 * @param {any} error - AxiosError, AxiosResponse (thrown by api helpers) or any other error
 * @returns {[string, string]} `[message, details]` to spread into `console.error(...)`:
 * `message` - error message or 'API error' if there is none
 * `details` - masked JSON with status, method, url, headers, response data and stack
 */
export const stringifyError = (error: any): [string, string] => {
  const { config, response } = error || {};
  const message = error?.message ?? 'API error';

  try {
    return [message, maskSensitiveData(JSON.stringify({
      message: error?.message,
      status: error?.status ?? response?.status,
      method: config?.method,
      url: config && `${config.baseURL}/${config.url}`,
      headers: config?.headers,
      data: error?.data ?? response?.data,
      stack: error?.stack,
    }))];
  } catch {
    return [message, 'Failed to stringify error'];
  }
};
